import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export type OrgCategory = "public" | "internal" | "personal";

/**
 * Extract unique directory prefixes from document source paths.
 *
 * For paths containing a `/` (beyond position 0), extracts everything
 * up to and including the last `/`.
 *
 * For single-segment values (no `/`), includes them as-is since they
 * may represent top-level directory names.
 */
export function extractDirectoryPrefixes(docSources: string[]): string[] {
  const prefixes = new Set<string>();
  for (const source of docSources) {
    if (!source) continue;
    const lastSlash = source.lastIndexOf("/");
    if (lastSlash > 0) {
      prefixes.add(source.slice(0, lastSlash + 1));
    } else if (lastSlash === -1) {
      prefixes.add(source);
    }
  }
  return [...prefixes].sort();
}

export function useOrgDocuments(orgCategory?: OrgCategory, orgId?: string) {
  return useQuery({
    queryKey: ["listDocumentsByOrg", orgCategory, orgId],
    queryFn: async () =>
      api.listDocumentsByOrg(orgCategory!, orgId!),
    enabled: !!orgCategory && !!orgId,
  });
}
